/**
 * Ensure the user is logged in before committing a form. Displays the
 * login dialog if they are not, and holds up form submission until the
 * dialog has either been successfully completed and the user signed in,
 * or the user cancels in which case the validation results in an error.
 * @constructor
 * @param {Foundation.Form} form
 * @implements {Foundation.Form.Validator}
 */
Foundation.Form.Validator.Login = function (form) {
    /**
     * @type {Foundation.Form}
     * @private
     */
    this._form = form;

    /**
     * @type {Object.<string,string>}
     * @private
     */
    this._feelingShyLoginData = null;
};

Foundation.Form.Validator.Login.prototype.identifier = function () {
    return "login";
};

/**
 * @param {jQuery} formElements
 */
Foundation.Form.Validator.Login.prototype.validate = function (formElements) {
    var loginPromise = new Foundation.Promise();

    // Clear out any previous feeling shy data.
    this._feelingShyLoginData = null;

    // Only authenticate if there's an element marked as requiring validation.
    if (formElements.length) {
        var options = formElements.data("validateLoginOptions") || {};

        var sessionManager = Foundation.Session.Manager.sharedInstance();
        if (sessionManager.isAuthenticated()) {
            // If the user is already logged in, we're done.
            loginPromise.fulfill();
        }
        else {
            // Ok, we're not logged in so show the login dialog.
            var dialog = new Foundation.Login.Dialog(options);
            dialog.setFeelingShyLogInDelegate(this.feelingShyLogin.bind(this));

            // Once the login dialog box is closed, we can check if the
            // user succeeded in logging in or feeling shy.
            dialog.closed().then(function () {
                if (sessionManager.isAuthenticated()) {
                    loginPromise.fulfill();
                }
                else if (this._feelingShyLoginData) {
                    loginPromise.fulfill();
                }
                else {
                    loginPromise.fail();
                }
            }.bind(this));
        }
    }
    else {
        // Form doesn't require authentication, so we're done.
        loginPromise.fulfill();
    }

    return loginPromise;
};

/**
 * @param {Object.<string,string>} shyData
 */
Foundation.Form.Validator.Login.prototype.feelingShyLogin = function (shyData) {
    this._feelingShyLoginData = shyData;
    this._form.updateFeelingShyDelegate(shyData);
};

Foundation.Form.registerValidator(Foundation.Form.Validator.Login);
